module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noChanges":"No changes has been done to this setting","user":"Username","oldValue":"Old value","newValue":"New value","changeDate":"Change Date","cancelLabel":"Cancle"},"no":{"noChanges":"Ingen endringer gjort med denne settingen","user":"Brukernavn","oldValue":"Gammel verdi","newValue":"Ny verdi","changeDate":"Endret dato","cancelLabel":"Lukk"}}')
  delete Component.options._Ctor
}
